exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".thumbnail-wrap .round-image{border-radius:50%}.thumbnail-wrap .thumbnail-text{color:#2481ff}.thumbnail-wrap-vertical{text-align:center}.thumbnail-wrap-vertical .round-image{margin-bottom:10px}.thumbnail-wrap-horizontal{display:inline-block}.thumbnail-wrap-horizontal .round-image{margin-right:10px}.thumbnail-wrap-horizontal .thumbnail-text{display:inline-block;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b0ac60b","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/thumbnail/src/main.vue
// module id = 631
// module chunks = 23